import gql from "graphql-tag";
import { apolloProvider } from "../../../main"

export const seleccionar_para_dbs = async (input) => { 
    const sql = gql`mutation seleccionar_para_dbs($input: NewSeleccionOfertaDbs!) {
        seleccionar_para_dbs(input: $input) {
          id
          proyecto_vinculado_id
          programa_universidad_id
          proyecto_id
          sede_portal_id
          sede_portal_name
          coordinador_usuario_id
          estado_aprobacion
          aprobado_por_id
          fecha_aprobacion
          fecha_registro 
        }
    }`;
    
    const ap = apolloProvider.clients.cliente_proys 
    const r = await ap.mutate({ mutation: sql, variables: {input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const aprobar_seleccionado = async (input) => { 
    const sql = gql`
    mutation aprobar_seleccionado($input:NewAprobarOfertaDbs!){
        aprobar_seleccionado(input:$input){id estado_aprobacion aprobado_por_id fecha_aprobacion}
    }
    `;
    
    const ap = apolloProvider.clients.cliente_proys 
    const r = await ap.mutate({ mutation: sql, variables: {input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const desaprobar_seleccionado = async (input) => { 
    const sql = gql`
    mutation desaprobar_seleccionado($input:NewDesaprobarOfertaDbs!){
        desaprobar_seleccionado(input:$input){id estado_aprobacion aprobado_por_id}
    }
    `;
    
    const ap = apolloProvider.clients.cliente_proys 
    const r = await ap.mutate({ mutation: sql, variables: {input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const crear_periodoSeleccion = async (input) => { 
    const sql = gql`
    mutation crear_periodoSeleccion($input:NewPeriodoSeleccion!){
        crear_periodoSeleccion(input:$input){
            id
            unidad_negocio_id
            creado_por_id
            tipo_periodo
            fecha_inicio
            fecha_final
            estado
            fecha_registro
        }
    }
    `;
    
    const ap = apolloProvider.clients.cliente_proys 
    const r = await ap.mutate({ mutation: sql, variables: {input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const down_periodoSeleccion = async (input) => { 
    const sql = gql`
    mutation down_periodoSeleccion($input:DownPeriodoSeleccion!){
        down_periodoSeleccion(input:$input){id estado}
    }
    `;
    
    const ap = apolloProvider.clients.cliente_proys 
    const r = await ap.mutate({ mutation: sql, variables: {input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const periodos_seleccion = async (q) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`
        query periodos_seleccion($q:QueryPeriodosSeleccion!){
            periodos_seleccion(q:$q){
                id
                unidad_negocio_id
                creado_por_id
                tipo_periodo
                fecha_inicio
                fecha_final
                estado
                fecha_registro
            }
        }
    `;
    const r = await ap.query({ query: sql, variables:{q:q}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const solicitar_fecha_campania = async (input) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`
        mutation solicitar_fecha_campania($input:NewFechasCampania!){
            solicitar_fecha_campania(input:$input){
                id
                programa_seleccionado_id
                fecha_inicio
                fecha_final
                solicitado_por_id
                respondido_por_id
                estado
                fecha_registro
            }
        }
    `;
    const r = await ap.mutate({ mutation: sql, variables:{input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const reprogramar_fecha_campania = async (input) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`
        mutation reprogramar_fecha_campania($input:NewFechasCampania!){
            reprogramar_fecha_campania(input:$input){
                id
                programa_seleccionado_id
                fecha_inicio
                fecha_final
                solicitado_por_id
                respondido_por_id
                estado
                fecha_registro
            }
        }
    `;
    const r = await ap.mutate({ mutation: sql, variables:{input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const responder_fecha_campania = async (input) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`
        mutation responder_fecha_campania($input:StatusFechasCampania!){
            responder_fecha_campania(input:$input){
                id
                programa_seleccionado_id
                fecha_inicio
                fecha_final
                solicitado_por_id
                respondido_por_id
                estado
                fecha_registro
            }
        }
    `;
    const r = await ap.mutate({ mutation: sql, variables:{input:input}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const oferta_esam_listado = async (q) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`
        query oferta_esam_listado($q:QueryListaOfertaAcad!){
            oferta_esam_listado(q:$q){
                sede_name
                sede_portal_name
                mes
                anio
                convenio
                area_programa
                tipo_programa
                programa_nombre
                programa_codigo
                modalidad_proyecto
                tipo_desarrollo
                estado_aprobacion
                fecha_inicio_campania
                fecha_fin_campania
                estado_final
                fecha_inicio_campania_reprog
                fecha_fin_campania_reprog
                codigo_sys_esam
                inscritos_sys_esam
                fecha_primer_inscrito
                dias_oferta_vigente
                dias_oferta_vigente_reprog
                dias_limite
                programa_coordinador_id
                programa_coordinador
                programa_responsable_id
                programa_responsable
                programa_universidad_codigo
                asociado_programa_con_programa_universidad
            }
        }
    `;
    const r = await ap.query({ query: sql, variables:{q:q}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const periodo_seleccion = async (unidad) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`
    query periodo_seleccion($unidad:ID!){
        periodo_seleccion(unidad:$unidad){id fecha_inicio fecha_final estado}
    }
    `;
    const r = await ap.query({ query: sql, variables:{unidad:unidad}  }).then(({data}) => data).catch((error) => error);
    return r
}

export const seleccionados_dbs = async (q) => { 
    const ap = apolloProvider.clients.cliente_proys 
    const sql = gql`query seleccionados_dbs($q:QuerySeleccionados!) { seleccionados_dbs(q: $q) { id proyecto_vinculado_id programa_universidad_id proyecto_id sede_portal_id sede_portal_name coordinador_usuario_id postgrado_id estado_aprobacion texto_rechazo lista_de_oferta aprobado_por_id fecha_aprobacion fecha_registro nombre_proyecto sede_id sede_name unidad_negocio_id ultima_campania{id programa_seleccionado_id fecha_inicio fecha_final estado respondido_por_id} ultima_reg_prog{id programa_seleccionado_id fecha_inicio fecha_final estado respondido_por_id}} }`;
    const r = await ap.query({ query: sql, variables:{q:q}  }).then(({data}) => data).catch((error) => error);
    return r
}